<IziGrid class="container">
  <IziCol>
    <img :src="src" alt="avatar" class="avatar" />
  </IziCol>
</IziGrid>